import { render } from "./UsabillaInPageComponent.vue?vue&type=template&id=517d5ed4&ts=true"
import script from "./UsabillaInPageComponent?vue&type=script&lang=ts"
export * from "./UsabillaInPageComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__